import '../scss/app.scss'
import { MainMenu, Swup } from './components'
import router from './router'

window.addEventListener('load', async () => {
  await router()
})
const menu = new MainMenu('.main-nav')
menu.init()
Swup(menu)